export enum StatusCategory {
  Pending = '1',
  Completed = '2',
}
